export default "__VITE_ASSET__CKQOS057__"